import { __exports as ValidationRules } from './_virtual-ValidationRules.js';

var hasRequiredValidationRules;

function requireValidationRules () {
	if (hasRequiredValidationRules) return ValidationRules;
	hasRequiredValidationRules = 1;

	Object.defineProperty(ValidationRules, "__esModule", {
	  value: true
	});
	ValidationRules.getErrors = getErrors;
	ValidationRules.validate = void 0;
	function isCurrency(data, paramName) {
	  return () => {
	    if (data && typeof data === 'string' && data.length === 3) {
	      return;
	    }
	    return "validation failed: ".concat(paramName, " invalid value, needs a string with length 3, current value: ").concat(data);
	  };
	}
	function isDecimalPositive(data, paramName) {
	  return () => {
	    if (data !== undefined && typeof data === 'number' && !isNaN(data) && data > 0) {
	      return;
	    }
	    return "validation failed: ".concat(paramName, " invalid value, needs a number greater than 0, current value: ").concat(data);
	  };
	}
	function isNotNegativeDecimal(data, paramName) {
	  return () => {
	    if (data !== undefined && typeof data === 'number' && !isNaN(data) && data >= 0) {
	      return;
	    }
	    return "validation failed: ".concat(paramName, " invalid value, needs a number greater or equal than 0, current value: ").concat(data);
	  };
	}
	function isDecimal(data, paramName) {
	  return () => {
	    if (data !== undefined && typeof data === 'number' && !isNaN(data)) {
	      return;
	    }
	    return "validation failed: ".concat(paramName, " invalid value, needs a decimal, current value: ").concat(data);
	  };
	}
	function isIntegerPositive(data, paramName) {
	  return () => {
	    if (data !== undefined && typeof data === 'number' && Number.isInteger(data) && !isNaN(data) && data > 0) {
	      return;
	    }
	    return "validation failed: ".concat(paramName, " invalid value, needs an integer greater than 0, current value: ").concat(data);
	  };
	}
	function isInteger(data, paramName) {
	  return () => {
	    if (data !== undefined && typeof data === 'number' && Number.isInteger(data) && !isNaN(data)) {
	      return;
	    }
	    return "validation failed: ".concat(paramName, " invalid value, needs integer greater equals to 0, current value: ").concat(data);
	  };
	}
	function isString(data, paramName) {
	  return () => {
	    if (data || typeof data !== 'string') {
	      return;
	    }
	    return "validation failed: ".concat(paramName, " invalid value, needs a string, current value: ").concat(data);
	  };
	}
	function isBoolean(data, paramName) {
	  return () => {
	    if (data !== undefined && typeof data === 'boolean') {
	      return;
	    }
	    return "validation failed: ".concat(paramName, " invalid value, needs a boolean, current value: ").concat(data);
	  };
	}
	function isBooleanOrUndefined(data, paramName) {
	  return () => {
	    if (data === undefined || typeof data === 'boolean') {
	      return;
	    }
	    return "validation failed: ".concat(paramName, " invalid value, needs a boolean or undefined, current value: ").concat(data);
	  };
	}
	function getErrors(validators) {
	  const errors = [];
	  validators.forEach(validator => {
	    const error = validator();
	    if (error) {
	      errors.push(error);
	    }
	  });
	  return errors;
	}
	ValidationRules.validate = {
	  isCurrency,
	  isDecimalPositive,
	  isDecimal,
	  isNotNegativeDecimal,
	  isIntegerPositive,
	  isInteger,
	  isString,
	  isBoolean,
	  isBooleanOrUndefined
	};
	
	return ValidationRules;
}

export { requireValidationRules as __require };
//# sourceMappingURL=vp-js-token-engine-build-tokenGenerators-ValidationRules.js.map
